import React, { useRef, useState } from 'react';
import { Typography, TextField, Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import Fade from '@mui/material/Fade';

import { commentPost } from '../../actions/posts';
import useStyles from './styles';

const CommentSection = ({ post }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [comments, setComments] = useState(post?.comments);
    const [comment, setComment] = useState('');
    const user = JSON.parse(localStorage.getItem('profile'));

    // function to add new comments.
    const handleClick = async () => {
        let checkComment = comment.trim();
        if(checkComment === '') return;

        let finalComment = `${user?.result?.name || user?.user?.displayName}: ${checkComment}`;
        // Since we return the new comments when calling the below dispatch we can use it to update the new comments like real time.
        const newComments = await dispatch(commentPost(finalComment, post._id));
        setComments(newComments);
        setComment('');
    }

    // css for laptop screen size & style the comments.

  return (
    <div>
        <div className={classes.commentsOuterContainer}>
            <div className={classes.commentsInnerContainer}>
                <Typography gutterBottom variant="h6">Comments</Typography>
                {/* Here will loop over the comments */}
                {comments?.map((c,i) => (
                    <Fade in key={i}>
                        <Typography gutterBottom variant='subtitle1'>
                            <fieldset style={{ border: '1px solid lightgray', borderRadius: '5px', }}>
                                <legend>{c.split(': ')[0].toUpperCase()}</legend>
                                {c.split(':')[1]}
                            </fieldset>
                        </Typography>
                    </Fade>
                ))}
           </div>
            {user && (
                <div className={classes.commentInput}>
                    <Typography gutterBottom variant="h6">Write Your Comment</Typography>
                    <TextField 
                        fullWidth 
                        rows={4} 
                        variant='outlined' 
                        label='Comment' 
                        multiline 
                        value={comment} 
                        onChange={(e) => setComment(e.target.value)}
                    />
                    <Button style={{ marginTop: '10px' }} fullWidth disabled={!comment} variant='contained' color='primary' onClick={handleClick} >
                        Comment
                    </Button>
                </div>
            )}
        </div>
    </div>
  )
}

export default CommentSection;